module.exports = __webpack_public_path__ + "img/leumi-obk-small.bb48c408.svg";